import { sortBy } from 'lodash-es';

import { QuarterCloseChecklistRowSections } from '@shared/store/workflow/workflow-types';
import { Workflow } from '@shared/store/workflow/workflow.store';

import { QuarterCloseChecklistSection } from '../models/quarter-close-checklist.model';

export function getLockAllWorkflows(
  section: QuarterCloseChecklistSection,
  workflowList: Workflow[]
): Workflow[] {
  if (!section || !workflowList || !workflowList.length) {
    return [];
  }

  const sectionType = Object.values(QuarterCloseChecklistRowSections).find(
    (workflowSection) => workflowSection === section.toString()
  );

  const workflowsFiltered = workflowList.filter(
    (workflow) => workflow.section === sectionType && !workflow.properties.locked
  );

  return sortBy(workflowsFiltered, ['order']);
}
